import React from 'react';
import { Chip } from '@mui/material';

interface StatusChipProps {
  status: 'Active' | 'Inactive' | 'Pending' | 'Expired' | 'Maintenance';
  size?: 'small' | 'medium';
}

const StatusChip: React.FC<StatusChipProps> = ({ status, size = 'small' }) => {
  const getStatusConfig = (status: string) => {
    switch (status) {
      case 'Active':
        return {
          label: 'Active',
          color: 'success' as const,
          variant: 'filled' as const,
          sx: {
            backgroundColor: '#4caf50',
            color: 'white',
            fontWeight: 600,
            '&:hover': {
              backgroundColor: '#45a049',
            },
          },
        };
      case 'Inactive':
        return {
          label: 'Inactive',
          color: 'error' as const,
          variant: 'filled' as const,
          sx: {
            backgroundColor: '#f44336',
            color: 'white',
            fontWeight: 600,
            '&:hover': {
              backgroundColor: '#da190b',
            },
          },
        };
      case 'Pending':
        return {
          label: 'Pending',
          color: 'warning' as const,
          variant: 'filled' as const,
          sx: {
            backgroundColor: '#ff9800',
            color: 'white',
            fontWeight: 600,
            '&:hover': {
              backgroundColor: '#e68900',
            },
          },
        };
      case 'Expired':
        return {
          label: 'Expired',
          color: 'error' as const,
          variant: 'filled' as const,
          sx: {
            backgroundColor: '#9e9e9e',
            color: 'white',
            fontWeight: 600,
            '&:hover': {
              backgroundColor: '#757575',
            },
          },
        };
      case 'Maintenance':
        return {
          label: 'Maintenance',
          color: 'info' as const,
          variant: 'filled' as const,
          sx: {
            backgroundColor: '#2196f3',
            color: 'white',
            fontWeight: 600,
            '&:hover': {
              backgroundColor: '#1976d2',
            },
          },
        };
      default:
        return {
          label: status,
          color: 'default' as const,
          variant: 'outlined' as const,
          sx: {
            backgroundColor: '#e0e0e0',
            color: '#424242',
            fontWeight: 600,
          },
        };
    }
  };

  const config = getStatusConfig(status);

  return (
    <Chip
      label={config.label}
      color={config.color}
      variant={config.variant}
      size={size}
      sx={config.sx}
    />
  );
};

export default StatusChip;
